import type { Subcircle } from "../hooks/useSubcircles";

export type ViewCountInput = {
  seen?: number | null;
  total?: number | null;
};

/** Audience size for view % — 1 for direct, subcircle count when targeted, else org members. */
export function resolveNoticeAudienceSize(
  targetSubcircle: string | undefined,
  subcircles: Subcircle[],
  orgMemberCount: number,
  targetUserId?: string
): number {
  if ((targetUserId || "").trim()) {
    return 1;
  }
  const orgTotal = Number.isFinite(orgMemberCount)
    ? Math.max(0, Math.floor(orgMemberCount))
    : 0;
  const subcircleId = (targetSubcircle || "").trim();
  if (!subcircleId) {
    return orgTotal;
  }
  const circle = subcircles.find((c) => c.circleId === subcircleId);
  const memberCount = Number(circle?.memberCount);
  if (Number.isFinite(memberCount) && memberCount >= 0) {
    return Math.floor(memberCount);
  }
  return orgTotal;
}

export type NormalizedViewCount = {
  seen: number;
  total: number;
  percentage: number;
};

/** Coerce view counts and avoid NaN when total audience is zero. */
export function normalizeViewCount(
  input?: ViewCountInput | null
): NormalizedViewCount {
  const seenNum = Number(input?.seen);
  const totalNum = Number(input?.total);
  const seen = Number.isFinite(seenNum) ? Math.max(0, Math.floor(seenNum)) : 0;
  const total = Number.isFinite(totalNum) ? Math.max(0, Math.floor(totalNum)) : 0;
  const percentage =
    total > 0 ? Math.round((seen / total) * 100) : 0;

  return { seen, total, percentage };
}

export function formatViewCountSummary(input?: ViewCountInput | null): string {
  const { seen, total, percentage } = normalizeViewCount(input);
  return `${seen} of ${total} (${percentage}%)`;
}
